import React, { FC } from 'react';
import styles from './styles.module.css';

import { useQuoteApi } from 'Shared/services/Api';
import {
  GetDisclosuresResponseType,
  transformDisclosuresResponse,
  Disclosures,
} from 'QuoteApp/services/endpoints/GetDisclosures';

import { useAppContext } from 'QuoteApp/services/providers';

export const Disclaimer: FC = () => {
  const { appId } = useAppContext();

  const [{ data: disclosureData }] = useQuoteApi<GetDisclosuresResponseType>({
    url: `insurance_applications/${appId}/document_signatures/${Disclosures.Purchase}`,
    transformResponse: transformDisclosuresResponse,
  });

  return (
    <div className={styles.highlightSection}>
      <div
        className={styles.disclosure}
        dangerouslySetInnerHTML={disclosureData?.bodyTextSanitized}
      />
    </div>
  );
};
